/*
// src/index.js
// Version: 1.0.1 - Added GoogleReCaptchaProvider for reCAPTCHA v3
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

// IMPORTANT: Replace with your actual Site Key from Google reCAPTCHA v3 admin console
const RECAPTCHA_V3_SITE_KEY = "6LfAfFIrAAAAAAdedjdhM230fosdEtI6qyxtD6BV";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleReCaptchaProvider
      reCaptchaKey={RECAPTCHA_V3_SITE_KEY}
      scriptProps={{
        async: true, // Default: false
        defer: true, // Default: false
        appendTo: "head", // Default: "body"
        nonce: undefined // Optional
      }}
    >
      <App />
    </GoogleReCaptchaProvider>
  </React.StrictMode>
);
*/

//No reCAPTCHA
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // This is your Tailwind CSS setup file
import App from './App'; // This will be your main application component

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
